import { AlkLogger } from '@alk/core';
import { injectable } from 'inversify';
import { INotificationsService } from './notifications.interface';
import { ISessionDisposable, NotificationItemsListTransaction } from '../../../interfaces';
import { Observable, Subject } from 'rxjs';

@injectable()
export class NotificationsServiceMock implements INotificationsService, ISessionDisposable {
    stop(): void {
        AlkLogger.debug('[NotificationsMock#stop]');
    }

    notificationTransactionsObservable(): Observable<NotificationItemsListTransaction> {
        AlkLogger.debug('[NotificationsMock#transactionsObservable]');
        return new Subject<NotificationItemsListTransaction>().asObservable();
    }
}
